"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var window_container_api_1 = require("./window-container-api");
var base_window_container_api_1 = require("./base-window-container-api");
var BrowserApi = /** @class */ (function (_super) {
    __extends(BrowserApi, _super);
    function BrowserApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(BrowserApi.prototype, "type", {
        get: function () {
            return window_container_api_1.WindowContainerApiType.Browser;
        },
        enumerable: true,
        configurable: true
    });
    return BrowserApi;
}(base_window_container_api_1.BaseWindowContainerApi));
exports.BrowserApi = BrowserApi;
exports.browserApi = new BrowserApi();



//////////////////
// WEBPACK FOOTER
// /app/~/redi-window-container-web-lib/dist/business/browser-api.js
// module id = 41
// module chunks = 0